var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.33333V2L8.66667 2L10.86 4.19333L4.19333 10.86L2 8.66667L2 14H7.33333L5.14 11.8067L11.8067 5.14L14 7.33333Z",
    fill: "#DEDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomFullScreen);
export default __webpack_public_path__ + "static/media/zoom_full_screen.01d62f408b376ae330d4fc3fb48d624f.svg";
export { ForwardRef as ReactComponent };